import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlay, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ButtonSpinner',
    props: {
        title: null,
        wait: { type: Boolean, default: false },
        tooltip: { default: undefined },
        disabled: { type: Boolean, default: false }
    },
    setup(__props) {
        library.add(faPlay, faSpinner);
        return { __sfc: true, faPlay, faSpinner, FontAwesomeIcon, BButton };
    }
});
